<template>
  <article id="testimonials">
    <header>
      <p class="s5 light">
        {{ $t("general.utilisateurs-donnent-avis") }}
      </p>
    </header>
    <div id="avatars_container">
      <button
        v-for="testimonial in testimonials"
        :key="testimonial.id"
        class="button"
        @click="changeTestimonial(testimonial.id)"
      >
        <Avatar
          :class="{ active : currentId === testimonial.id, }"
          :img-name="testimonial.img"
        />
      </button>
    </div>
    <figure>
      <blockquote class="text-regular italic">
        <p v-html="`&ldquo;${currentTestimonial.texte}&rdquo;`" />
      </blockquote>
      <figcaption>
        <span class="text-medium">{{ currentTestimonial.nom }}</span>
        <span class="text-regular bold">{{ currentTestimonial.statut }}</span>
      </figcaption>
    </figure>
  </article>
</template>

<script>
import Avatar from "../../components/avatar/Avatar.vue";

export default {
  name: "Testimonials",
  components: {
    Avatar,
  },
  props: {
    /**
     * Informations des témoignages.
     */
    testimonials: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentId: 2,
    };
  },
  computed: {
    currentTestimonial() {
      return this.testimonials.find((testimonal) => testimonal.id === this.currentId);
    },
  },
  methods: {
    /**
     * Change l'id de témoignage.
     * @param {Number} id à changer.
     */
    changeTestimonial(id) {
      this.currentId = id;
    },
  },
};
</script>

<style lang="scss">
@use "../../assets/styles/components/customers/testimonials.scss";
</style>
